module.exports = __webpack_public_path__ + "img/logo.92537d4a.png";